/** @jsx jsx */

import { Colors } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    border-style: none;
    border-bottom: 1px solid ${Colors.GrayWarm4};
    width: 100%;
    margin: 0px;
  `,
};

/**
 * Renders a divider to separate sections.
 *
 * @param props
 */
function Divider() {
  return <hr css={Styles.root} />;
}

export default Divider;
